import React from 'react';

export const CompensationTypeDescription = (
  <va-additional-info
    trigger="Why we ask for this information"
    class="vads-u-margin-top--2 vads-u-margin-bottom--3"
    uswds
  >
    <div>
      <p className="vads-u-margin-top--0">
        We use this information to help us decide these 4 things:
      </p>

      <ul>
        <li>
          If you can fill out a shorter application, <strong>and</strong>
        </li>
        <li>
          What types of VA health care benefits you’re eligible for,{' '}
          <strong>and</strong>
        </li>
        <li>
          How soon we enroll you in VA health care, <strong>and</strong>
        </li>
        <li>
          How much (if anything) you’ll have to pay toward the cost of your care
        </li>
      </ul>

      <p className="vads-u-margin-bottom--0">
        We give veterans with service-connected disabilities the highest
        priority.
      </p>
    </div>
  </va-additional-info>
);
